<template>
  <div class="col-sm-4 col-sm-offset-4">
    <h2>Authentification</h2>
    <p>Veuillez vous authentifier.</p>
    <div class="alert alert-danger" v-if="error">
      <p>{{ error }}</p>
    </div>
  </div>
</template>

<script>
import auth from '@/auth'

export default {

  data() {
    return {
      error: ''
    }
  },
  created(){
    auth.login()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/Authentification.vue